import { render } from "./SubjectSelects.vue?vue&type=template&id=4b348892&scoped=true"
import script from "./SubjectSelects.vue?vue&type=script&lang=js"
export * from "./SubjectSelects.vue?vue&type=script&lang=js"

import "./SubjectSelects.vue?vue&type=style&index=0&id=4b348892&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b348892"]])

export default __exports__